import { render, staticRenderFns } from "./ApprovalGroupList.vue?vue&type=template&id=24fb72ba&"
import script from "./ApprovalGroupList.vue?vue&type=script&lang=js&"
export * from "./ApprovalGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fb72ba')) {
      api.createRecord('24fb72ba', component.options)
    } else {
      api.reload('24fb72ba', component.options)
    }
    module.hot.accept("./ApprovalGroupList.vue?vue&type=template&id=24fb72ba&", function () {
      api.rerender('24fb72ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/security/approval-group/ApprovalGroupList.vue"
export default component.exports